import { useEffect } from 'react';

// @ts-expect-error no types provided
import { useTagManager } from '@xingternal/winery-tag-manager';

import { useUserHashedEmail } from '../use-user-hashed-email/use-user-hashed-email';
import useHost from '../use-host/use-host';

export const useWineryTagManager = (
  options?: Record<string, unknown>
): void => {
  const { userHashedEmail, isUserHashedEmailLoading } = useUserHashedEmail();
  const { isPreview } = useHost();
  const env = isPreview ? 'preview' : 'production';
  const { initializeTagManagerOnce } = useTagManager({ env });
  useEffect(() => {
    if (!isUserHashedEmailLoading) {
      initializeTagManagerOnce({ bid: userHashedEmail, options });
    }
  }, [userHashedEmail, initializeTagManagerOnce, options]);
};
